import angular from 'angular';
import historyStorage from './historyStorage';

let cmsCreatorUndoRedo = {
    bindings: {
        onChange: '&',
        fieldValue: '='
    },
    template: require('./undoRedo.html'),
    controller: function (historyStorage) {

        this.undo = () => {
            historyStorage.back();
        };

        this.redo = () => {
            historyStorage.next();
        };

        this.undoDisabled = () => {
            return historyStorage.getCounter() <= 0
        };

        this.redoDisabled = () => {
            return historyStorage.getCounter() +1 >= historyStorage.getStackLength();
        };

    }

};

export default angular.module('cms.creator.undo-redo', [historyStorage])
    .component('cmsCreatorUndoRedo', cmsCreatorUndoRedo)
    .name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/UndoRedo/undoRedo.js